export enum ConfigurationType {
  Agent = "Agent",
  AutonomousAgent = "AutonomousAgent",
  Account = "Account"
}
